// @flow

import { SAVE_CONFIG_MODAL_OPEN } from './constants';
import SaveConfigModal from './saveConfigModal';

export {
  SAVE_CONFIG_MODAL_OPEN,
};

export default SaveConfigModal;
